import type { Question } from '@mentimeter/http-clients';
import React from 'react';

export function useViewSizeChange(question: Question) {
  const [size, setSize] = React.useState({ width: 0, height: 0 });
  const container = React.useRef<HTMLDivElement | null>(null);

  React.useLayoutEffect(() => {
    if (container.current) {
      setSize({
        width: container.current.offsetWidth,
        height: container.current.offsetHeight,
      });
    }
  }, [
    // Run measurement whenever any size affecting data changes
    question.title_meta,
    question.question,
    question.question_description,
    question.layout?.font_size_offset,
    question.layout?.type,
    question.layout?.size,
    question.choices,
    container,
  ]);

  return { size, container };
}
